<template>
    <div>
        <!-- Affichage mobile: avec un swipe sur une ligne -->
        <div class="row d-lg-none swiper-1row">
            <div class="col-12">
                <div class="accessories-swiper-container">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(accessory, indexAccessory) in accessories"
                            :key="accessory.defaultVersion.idSeo.value"
                            class="swiper-slide"
                        >
                            <AccessoryCard
                                :id="'accessory-card-' + indexAccessory"
                                :accessory="accessory"
                                :das-dto="dasDto"
                                :open-card-button-label="openCardButtonLabel"
                                :advantage-messages="advantageMessages"
                                :compact-promo-messages-dto="compactPromoMessagesDto"
                                :accessory-ctrl="accessoryCtrl"
                                @accessory-updated="onUpdate"
                                @accessory-error="onError"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Affichage desktop: une grille de 3 colonnes -->
        <div class="d-none d-lg-block d-xl-block d-xxl-none grid-3col">
            <div v-for="y in numberOfRows(3)" :key="'desktop-3-card-y-' + y" class="row">
                <div v-for="x in 3" :key="'desktop-3-card-x-' + x" class="col-4">
                    <AccessoryCard
                        v-if="index(x, y, 3) < maxNumberOfVisibleAccessories(3)"
                        :id="'accessory-card-'+ index(x, y, 3) + '-grid-3col'"
                        :accessory="accessories[index(x, y, 3)]"
                        :das-dto="dasDto"
                        :open-card-button-label="openCardButtonLabel"
                        :advantage-messages="advantageMessages"
                        :compact-promo-messages-dto="compactPromoMessagesDto"
                        :accessory-ctrl="accessoryCtrl"
                        class="mb-2"
                        @accessory-updated="onUpdate"
                        @accessory-error="onError"
                    />
                </div>
            </div>

            <!-- le bouton "voir plus" -->
            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <button
                        v-if="visibleRowsCount < numberOfRows(3)"
                        class="ob1-link-arrow"
                        aria-expanded="false"
                        @click="onMoreAccessoryButtonClickCol3"
                    >
                        Voir plus d’accessoires
                    </button>
                </div>
            </div>
        </div>

        <!-- Affichage desktop: une grille de 4 colonnes -->
        <div class="d-none d-xxl-block grid-4col">
            <div v-for="y in numberOfRows(4)" :key="'desktop-4-card-y-' + y" class="row">
                <div v-for="x in 4" :key="'desktop-4-card-x-' + x" class="col-3">
                    <AccessoryCard
                        v-if="index(x, y, 4) < maxNumberOfVisibleAccessories(4)"
                        :id="'accessory-card-'+ index(x, y, 4) + '-grid-4col'"
                        :accessory="accessories[index(x, y, 4)]"
                        :das-dto="dasDto"
                        :open-card-button-label="openCardButtonLabel"
                        :advantage-messages="advantageMessages"
                        :compact-promo-messages-dto="compactPromoMessagesDto"
                        :accessory-ctrl="accessoryCtrl"
                        class="mb-2"
                        @accessory-updated="onUpdate"
                        @accessory-error="onError"
                    />
                </div>
            </div>

            <!-- le bouton "voir plus" -->
            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <button
                        v-if="visibleRowsCount < numberOfRows(4)"
                        class="ob1-link-arrow"
                        aria-expanded="false"
                        @click="onMoreAccessoryButtonClickCol4"
                    >
                        Voir plus d’accessoires
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccessoryCard from "./AccessoryCard.vue";

export default {
    components: {AccessoryCard},
    props: {
        accessories: {
            type: Array,
            required: true,
        },
        accessoryCtrl: {
            type: Object,
            required: true
        },
        dasDto: {
            type: Object,
            required: true
        },
        openCardButtonLabel: {
            type: String,
            default: "Choisir"
        },
        advantageMessages: {
            type: Object,
            required: true
        },
        compactPromoMessagesDto: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            visibleRowsCount: 1,
            accessoriesModelView: [],
        }
    },
    computed: {
        hasAnyDas() {
            return this.accessories.some(accessory => accessory.das);
        },
        hasAnyAdvantage() {
            return this.accessories.some(accessory => accessory.defaultVersion.odrData || accessory.defaultVersion.promoData);
        },
        hasVersions() {
            return this.accessories.some(accessory => accessory.versions && accessory.versions.length > 1);
        },
        hasAccessories() {
            return this.accessories.length > 0;
        }
    },
    mounted() {
        const swiper = new Swiper(".accessories-swiper-container", {
            slidesPerView: "auto",
            spaceBetween: 30,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initialSlide: 0,
            breakpoints: {
                320: {
                    spaceBetween: 16,
                },
                480: {
                    spaceBetween: 30,
                }
            }
        });
        window.addEventListener("resize", () => {
            this.updateLayout();
        });
        this.updateLayout();
    },
    methods: {
        updateLayout() {
            this.alignCardItemsVertically(".swiper-1row");
            this.alignCardItemsVertically(".grid-3col");
            this.alignCardItemsVertically(".grid-4col");
        },
        alignCardItemsVertically(baseSelector) {
            this.alignItemsVertically(baseSelector + " " + ".accessory-card-name");
            if (this.hasVersions) {
                this.alignItemsVertically(baseSelector + " " + ".accessory-card-versions");
            }
            this.alignItemsVertically(baseSelector + " " + ".accessory-card-price");
            if (this.hasAnyAdvantage) {
                this.alignItemsVertically(baseSelector + " " + ".accessory-card-advantage");
            }
            if (this.hasAnyDas) {
                this.alignItemsVertically(baseSelector + " " + ".accessory-card-das");
            }
            this.alignItemsVertically(baseSelector + " " + ".accessory-card-cta");
        },
        getMaximumHeight(selector) {
            const elts = Array.from(document.querySelectorAll(selector));
            const heights = elts.map((elt) => {
                return $(elt).height();
            });
            return Math.max(...heights);
        },
        alignItemsVertically(selector) {
            const elts = Array.from(document.querySelectorAll(selector));
            elts.forEach(elt => elt.style.removeProperty("height"));
            const maxHeight = this.getMaximumHeight(selector);
            if (maxHeight === 0) {
                return;
            }
            elts.forEach(elt => $(elt).height(maxHeight));
        },
        // Renvoie le nombre de row pour un nombre de colonne donnée
        numberOfRows(col) {
            if (this.accessories.length === 0) {
                return 1;
            }
            return Math.trunc((this.accessories.length - 1) / col) + 1;
        },
        maxNumberOfVisibleAccessories(col) {
            return Math.min(this.visibleRowsCount * col, this.accessories.length);
        },
        onMoreAccessoryButtonClickCol3() {
            this.onMoreAccessoryButtonClick(3);
        },
        onMoreAccessoryButtonClickCol4() {
            this.onMoreAccessoryButtonClick(4);
        },
        onMoreAccessoryButtonClick(col) {
            this.visibleRowsCount += 1;

            // A la prochaine boucle de rendering, on réaligne le layout pour que
            // tous les éléments des tuiles visibles soient alignées.
            Vue.nextTick()
                .then(() => {
                    this.updateLayout();
                    // On scroll jusqu'à la nouvelle ligne de card visibles.
                    const id = this.gridId(1, this.visibleRowsCount, col);
                    // Il y a une fonction native de scroll (scrollIntoView)
                    // mais celle ci n'est pas supportée sur Safari iOS / macOS.
                    // On utilise celle de MyShop qui repose sur JQuery.
                    const selector = `#${id}`;
                    const durationInMs = 500;
                    const offset = -15;
                    this.scrollToSelector(selector, durationInMs, offset);
                    /** Code non supporté sur iOS / Safari
                     const elt = document.querySelector(`#${id}`);
                     if (elt !== null) {
                     elt.scrollIntoView({behavior: 'smooth'}); n'est pas supporté sur Safari macOS / iOS
                     scrollToSelector(
                     }
                     */
                });
        },
        index(x, y, col) {
            return (x - 1) + (y - 1) * col;
        },
        gridId(x, y, col) {
            const index = this.index(x, y, col);
            return `accessory-card-${index}-grid-${col}col`;
        },
        scrollToSelector(selector, durationInMs, offset) {
            $('body, html').animate({
                scrollTop: $(selector).offset().top + offset
            }, durationInMs);
        },
        onUpdate(result, status) {
            this.updated();
            this.$emit("accessory-updated", result, status)
        },
        onError(error) {
            this.$emit("accessory-error", error)
        },
        updated() {
            this.$nextTick(function () {
                const swiperContainer = document.querySelector('.accessories-swiper-container');
                if (swiperContainer !== null) {
                    const swiper = swiperContainer.swiper;
                    swiper.update();
                }
                this.updateLayout();
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'ob1_variables';

.swiper-1row > div {
    overflow: hidden;
}

.swiper-slide {
    width: 238px;
    @media(min-width: #{map-get($grid-breakpoints, sm)}) {
        width: 280px;
    }
}

</style>
